import Button from 'components/base/Button';
import { useState } from 'react';
import { Col, FloatingLabel, Form, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { videoProjectService } from 'services/videoService';

const VideoNew = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: '',
    description: '',
    rate: 0
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleChange = (field: string, value: string | number) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      setLoading(true);
      setError(null);

      // Validate rate is a positive number
      if (formData.rate <= 0) {
        setError('Taxa deve ser um valor positivo');
        return;
      }

      // Create video project using the service
      await videoProjectService.create(formData);

      // Navigate back to video list
      navigate('/app/video/projects');
    } catch (err) {
      console.error('Error creating video:', err);
      setError('Failed to create video project');
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    navigate('/app/video/projects');
  };

  return (
    <div>
      <h2 className="mb-4">Nova Captura</h2>

      {error && (
        <div className="alert alert-danger" role="alert">
          {error}
        </div>
      )}

      <Row>
        <Col xs={12} xl={9}>
          <Row as="form" className="g-3 mb-6" onSubmit={handleSubmit}>
            <Col xs={12}>
              <FloatingLabel
                controlId="floatingInputName"
                label="Nome da Captura"
              >
                <Form.Control
                  type="text"
                  placeholder="Nome da Captura"
                  value={formData.name}
                  onChange={e => handleChange('name', e.target.value)}
                  required
                />
              </FloatingLabel>
            </Col>
            <Col xs={12}>
              <FloatingLabel
                controlId="floatingTextareaDescription"
                label="Descrição"
              >
                <Form.Control
                  as="textarea"
                  placeholder="Descrição da captura"
                  style={{ height: '150px' }}
                  value={formData.description}
                  onChange={e => handleChange('description', e.target.value)}
                  required
                />
              </FloatingLabel>
            </Col>
            <Col xs={12}>
              <FloatingLabel
                controlId="floatingInputRate"
                label="Taxa de frames"
              >
                <Form.Control
                  type="number"
                  placeholder="Taxa por hora"
                  min="0"
                  step="1"
                  value={formData.rate}
                  onChange={e =>
                    handleChange('rate', parseFloat(e.target.value) || 0)
                  }
                  required
                />
              </FloatingLabel>
            </Col>
            <Col xs={12} className="gy-6">
              <div className="d-flex justify-content-end gap-3">
                <Button
                  variant="phoenix-primary"
                  className="px-5"
                  onClick={handleCancel}
                  disabled={loading}
                >
                  Cancelar
                </Button>
                <Button
                  variant="primary"
                  className="px-5 px-sm-15"
                  type="submit"
                  disabled={loading}
                >
                  {loading ? 'Criando...' : 'Criar Captura'}
                </Button>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
};

export default VideoNew;
